import {FormioBase} from "./formiobase";

export class EditGrid extends FormioBase {
  public inputType = "editgrid";
  public title = "Edit grid";
  public icon = "fa fa-tasks";
  public shouldBeRenderedByFormio = false;
  public schema: any = {
    title: "Edit grid",
    components: [{
      input: true,
      tree: true,
      components: [],
      multiple: true,
      hidden: false,
      tableView: true,
      label: "Edit grid",
      key: undefined,
      protected: false,
      persistent: true,
      clearOnHide: true,
      type: "editgrid",
      inputType: "editgrid",
      tags: [],
      enableRowGroups: true,
      validate: {
        minRows: 0,
        requiredRows: "",
      },
      templates: {
        header: "",
        row: "",
        footer: "",
      },
      customClass: "ds-editgrid",
    }],
  };
}
